/* eslint-disable no-negated-condition */
import React from 'react';

import styles from './ProgressBar.scss';

export default class ProgressBarWrapper extends React.Component {
  static defaultProps = {
    resetData: {
      state: '',
      children: [],
    },
  };

  state = {
    percentage: 0,
  };

  componentDidMount() {
    if (this.props.resetData.children && this.props.resetData.children.length) {
      const completed = this.props.resetData.children.filter(
        service =>
          service.state === 'COMPLETED' || service.state === 'TERMINATED',
      ).length;

      const totalCount = this.props.resetData.children.length;

      if (
        this.props.resetData.children.every(
          service =>
            service.state === 'COMPLETED' || service.state === 'TERMINATED',
        )
      ) {
        this.setState({ percentage: 100 });
      }

      this.setState({ percentage: (completed / totalCount) * 100 });
    }
  }

  render() {
    return (
      <div
        style={{ paddingBottom: '1em', display: 'flex', alignItems: 'center' }}
      >
        {this.state.percentage !== 0 ? (
          <ProgressBar percentage={this.state.percentage} />
        ) : null}
      </div>
    );
  }
}

const ProgressBar = props => {
  return (
    <div className={styles.progressBar}>
      <Filler percentage={props.percentage} />
    </div>
  );
};

const Filler = props => {
  return (
    <div className={styles.filler} style={{ width: `${props.percentage}%` }} />
  );
};
